import type { Maybe } from "@entrilia/shared/types.ts";
import { ReportType } from "../../../../../api/types/svTypes.ts";
import { chartRelatedReportTypes } from "./chartRelatedReport.types.ts";

export const usesTabularConfiguration = (reportType: Maybe<ReportType>) =>
  reportType === ReportType.Tabular || reportType === ReportType.CashFlow;

export const isTileReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.Tile;
};

export const isChartReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return chartRelatedReportTypes.includes(reportType);
};

export const isPivotReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.Pivot;
};

export const isListReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.List;
};

export const isFinancialStatementReportType = (reportType: Maybe<ReportType>): boolean => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.FinancialStatement;
};

export const getAllReportTypes = (): ReportType[] => {
  return [
    ReportType.Pivot,
    ReportType.Tabular,
    ReportType.CashFlow,
    ReportType.List,
    ...chartRelatedReportTypes,
    ReportType.Tile,
    ReportType.FinancialStatement,
  ];
};
